import { render, staticRenderFns } from "./orderAdjust.vue?vue&type=template&id=36c7693c&scoped=true&"
import script from "./orderAdjust.vue?vue&type=script&lang=js&"
export * from "./orderAdjust.vue?vue&type=script&lang=js&"
import style0 from "./orderAdjust.vue?vue&type=style&index=0&id=36c7693c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7693c",
  null
  
)

export default component.exports